import jwtAuthAxios from "../auth/jwtAuth";
import { setBackendDomain } from "./management";

export const getBindings = async () => {
  setBackendDomain(jwtAuthAxios);
  const response = await jwtAuthAxios.get("/api/v1/bindings");
  const data = response?.data;
  if (Array.isArray(data)) return data;
  if (Array.isArray(data?.items)) return data.items;
  if (Array.isArray(data?.bindings)) return data.bindings;
  return [];
};

export const getBinding = async (id) => {
  setBackendDomain(jwtAuthAxios);
  const response = await jwtAuthAxios.get(`/api/v1/bindings/${id}`);
  return response?.data || null;
};

export const createBinding = async (binding) => {
  setBackendDomain(jwtAuthAxios);
  const response = await jwtAuthAxios.post("/api/v1/bindings", binding);
  return response?.data || null;
};

export const updateBinding = async (binding) => {
  setBackendDomain(jwtAuthAxios);
  const response = await jwtAuthAxios.put(
    `/api/v1/bindings/${binding._id}`,
    binding
  );
  return response?.data || null;
};

export const deleteBinding = async (id) => {
  setBackendDomain(jwtAuthAxios);
  const response = await jwtAuthAxios.delete(`/api/v1/bindings/${id}`);
  return response?.data || null;
};

export const updateBindingsOrder = async (bindings) => {
  setBackendDomain(jwtAuthAxios);
  const response = await jwtAuthAxios.put("/api/v1/bindings/order", bindings);
  return response?.data || null;
};
